<template>
  <v-main>
    <v-container fluid>
      <v-row class="ma-0">
        <v-spacer/>
          <v-btn icon href="https://www.youtube.com/playlist?list=PL2a9kD1kP16dTMApbdGWurQ0kC-iKrip_">
              <v-icon>mdi-video</v-icon>
          </v-btn>
      </v-row>
      <!-- Generamos el menu que contiene todos los apartados -->
      <template v-for="(card) in cards">
        <!-- Mostramos solo la secciones con elementos -->
        <MenuCard v-if="card.items.filter(i => i.visible).length > 0" :title="card.title" :items="card.items"/>
      </template>
    </v-container>
  </v-main>
</template>

<script>
import { onMounted, computed, ref } from '@vue/composition-api'
import FormIntegraciones from "@/views/Marketing/components/FormIntegraciones";
import FormPasarelasPago from "@/views/Marketing/components/FormPasarelasPago";

export default {

  name: 'Configuracion',

  setup(props, {root}) {
    const user = computed(() => root.$store.getters['auth/user'])
    const centro = computed(() => root.$store.getters['centro/centro'])

      const go_to_ficha_proveedor = () => {
        if(root.$store.state.centro.centro.proveedor){
            root.$router.push({ name: 'ficha_proveedor', params: {id: root.$store.state.centro.centro.proveedor}})
        }
      }

    let cards = ref([])
    cards.value = [
      {
        title: root.$t("Empresa"),
        items: [
          { icon: 'mdi-store', text: root.$t('Centro'), dialog_component: 'centro', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-pencil-ruler', text: root.$t('Diseño'), route: 'diseno', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },

          { icon: 'mdi-account-group', text: root.$t('Empleados'), route: 'empleados',
            visible: (root.$store.state.auth.user.tipo_empleado === 'admin' || root.$store.getters['auth/has_permission']("configurar_horarios") || root.$store.getters['auth/has_permission']("view_objetivoempleado")) },
          { icon: 'mdi-content-copy', text: root.$t('Gastos'), route: 'gastos', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          {
            icon: 'mdi-credit-card-sync',
            text: root.$t('Actualizar tarjeta de crédito'),
            dialog_title: root.$t('Actualizar tarjeta de crédito'),
            dialog_component: 'DialogTarjetaCredito',
            visible: root.$store.state.auth.user.tipo_empleado === 'admin'
          },
        ]
      },
      {
        title: root.$t("Ventas"),
        items: [
          { icon: 'mdi-folder-open', text: root.$t('Categorias'), route: 'categorias', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-auto-fix', text: root.$t('Servicios'), route: 'servicios', visible: true },
          { icon: 'mdi-tag-multiple', text: root.$t('Productos'), route: 'productos', visible: true },
          { icon: 'mdi-star-circle', text: root.$t('Bonos'), route: 'bonos', visible: true },
          { icon: 'mdi-cube-outline', text: root.$t('Packs'), route: 'packs', visible: true },
          { icon: 'mdi-currency-usd', text: root.$t('Tarifas'), dialog_component: 'tarifas', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-receipt', text: root.$t('Tickets'), dialog_component: 'tickets', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-calculator', text: root.$t('Impuestos'), dialog_component: 'impuestos', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-circle-multiple', text: root.$t('Propinas'), dialog_component: 'propinas', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-handshake', text: root.$t('Suscripciones'), route: 'suscripciones', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-bank', text: root.$t('TBAI'), route: 'ticketbai', visible: (root.$store.state.auth.user.tipo_empleado === 'admin' && [672, 653, 700].includes(root.$store.state.centro.centro.provincia)) }
        ]
      },
      {
        title: root.$t("Agenda"),
        items: [
          { icon: 'mdi-calendar', text: root.$t('Horario'), route: 'horario', visible: (root.$store.state.auth.user.tipo_empleado === 'admin' || root.$store.getters['auth/has_permission']("configurar_horarios")) },
          { icon: 'mdi-calendar-lock', text: root.$t('Festivos'), route: 'festivos', visible: (root.$store.state.auth.user.tipo_empleado === 'admin' || root.$store.getters['auth/has_permission']("configurar_horarios")) },
        ]
      },
      {
        title: root.$t("Otros"),
        items: [
          { icon: 'mdi-truck', text: root.$t('Gestión proveedor'), method: go_to_ficha_proveedor, visible: (root.$store.state.centro.centro.is_central == true && root.$store.state.centro.centro.proveedor != null) },
          { icon: 'mdi-truck', text: root.$t('Proveedores'), route: 'proveedores', visible: (root.$store.state.centro.centro.proveedor == null && (root.$store.state.auth.user.tipo_empleado === 'admin' || root.$store.getters['auth/has_permission']("crear_pedidos"))) },
          { icon: 'mdi-cogs', text: root.$t('Recursos/cabinas'), route: 'recursos-cabinas', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-folder-open', text: root.$t('Categorías de cliente'), route: 'categorias-cliente', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-format-list-bulleted', text: root.$t('Cuestionarios'), route: 'cuestionarios', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-lock', text: root.$t('Seguridad'), route: 'seguridad', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-shield-account', text: root.$t('RGPD'), route: 'rgpd', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-file-check', text: root.$t('Consentimientos'), route: 'consentimientos', visible: root.$store.state.auth.user.tipo_empleado === 'admin' },
          { icon: 'mdi-account-clock', text: root.$t('Control asistencial'), route: 'control-asistencia', visible: true}
        ]
      }
    ]


    onMounted(async () => {
      if (root.$route.query['updated_card'] === 'true') {
        root.$snotify.success(
          root.$t("Acción realizada con éxito"),
          root.$t('Atención {0}', [root.$store.getters['auth/user'].first_name])
        )
      } else if (root.$route.query['updated_card'] === 'false') {
        root.$snotify.error(
          root.$t("Ha ocurrido un error"),
          root.$t('Atención {0}', [root.$store.getters['auth/user'].first_name])
        )
      }

      // Si es central eliminamos los elementos necesarios
      if(centro.value.is_central){
        // Eliminamos la sección agenda
        cards.value = cards.value.filter( function(c){
          return ![root.$t("Agenda")].includes(c.title)
        })

        // Eliminamos Centro, diseño, tarjeta de cŕedito de la card empresa
        let card_empresa = cards.value.filter((c) => c.title === root.$t("Empresa"))[0]
        card_empresa.items = card_empresa.items.filter(i => ![root.$t("Centro"), root.$t("Diseño")].includes(i.text))

        // Eliminamos Tarifas, tickets impuestos, propinas, suscripciones y ticket bai de la card Ventas
        let card_ventas = cards.value.filter((c) => c.title === root.$t("Ventas"))[0]
        card_ventas.items = card_ventas.items.filter(i => ![root.$t("Tarifas"), root.$t("Tickets"), root.$t("Impuestos"), root.$t("Propinas"), root.$t("Suscripciones"), root.$t("TBAI")].includes(i.text))

        // Eliminamos proveedores, recursos, categorías cliente, cuestionarios, seguridad, consentimientos
        let card_otros = cards.value.filter((c) => c.title === root.$t("Otros"))[0]
        card_otros.items = card_otros.items.filter(i => ![root.$t("Recursos/cabinas"), root.$t("Categorías de cliente"), root.$t("Cuestionarios"), root.$t("Seguridad"), root.$t("Consentimientos")].includes(i.text))
      }
    })

    return {
      cards
    }
  },
  components: {
    MenuCard: () => import('@/components/shared/MenuCard'),
  }
}
</script>

